import { joinRoom } from '~/actions/rooms';

export const auth = (dispatch, apiClient, credentials) => {
  dispatch({ type: 'USER_SELF_PENDING' });
  return apiClient
    .handshake(credentials)
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({
        type: 'COOKIE_SET',
        key: 'access_session',
        value: res.data.session
      });
    })
    .then(() => {
      return apiClient.setProtocol('ws');
    })
    .then(() =>
      apiClient.call({ endpoint: 'user/me' }).then(res => {
        if (res.status !== 200) {
          throw res;
        }
        dispatch({ type: 'USER_SELF_SET', user: res.data });
      })
    )
    .then(() => joinRoom(dispatch, apiClient, 'admin'))
    .catch(e => {
      dispatch({ type: 'USER_SELF_PENDING', pending: false });
      throw e;
    });
};

export const setPassword = (dispatch, apiClient, oldPassword, newPassword) => {
  dispatch({ type: 'USER_SELF_PENDING' });
  return apiClient
    .call({
      endpoint: 'user/changePassword',
      data: { oldPassword, newPassword }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'USER_SELF_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'Credentials updated',
        snackType: 'accept'
      });
    })
    .catch(e => {
      dispatch({ type: 'USER_SELF_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'Problem updating credentials',
        snackType: 'warning'
      });
      throw e;
    });
};

export const listUsers = (dispatch, apiClient) => {
  return apiClient
    .call({
      endpoint: 'user/listUsers'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'USER_LIST', list: res.data });
      return res;
    })
    .catch(e => {
      throw e;
    });
};

export const createUser = (dispatch, apiClient, username, password, name, permissions, level) => {
  return apiClient
    .call({
      endpoint: 'user/create',
      data: { username, password, name, permissions, level }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      listUsers(dispatch, apiClient);
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'User created',
        snackType: 'accept'
      });
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'Problem creating user',
        snackType: 'warning'
      });
      throw e;
    });
};

export const updateUser = (
  dispatch,
  apiClient,
  userId,
  password,
  name,
  level,
  status,
  permissions,
) => {
  const data = {
    userId,
    name,
    level,
    status,
    permissions,
  };
  if (password) {
    data.password = password;
  }
  return apiClient
    .call({
      endpoint: 'user/update',
      data
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'User updated',
        snackType: 'accept'
      });
      listUsers(dispatch, apiClient);
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'Problem updateding user',
        snackType: 'warning'
      });
      throw e;
    });
};

const loadingUsers = {};

export const findUserById = (dispatch, apiClient, userId = '') => {
  if (loadingUsers[userId]) {
    return Promise.resolve(true);
  }
  loadingUsers[userId] = true;
  return apiClient
    .call({
      endpoint: 'user/findUserById',
      data: { userId }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'USER_FIND_BY_ID', user: res.data });
      return res;
    });
};

export const clear = dispatch => {
  dispatch({ type: 'USER_SELF_CLEAR' });
  dispatch({ type: 'COOKIE_REMOVE', key: 'access_session' });
  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./app/actions/user.js